import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_88: FaireProductEntity = {
  token: "starter_collection_88",
  type: "product",
  name: "The Resting Stone",
  brandName: "Material",
  imageUrl:
    '"https://cdn.faire.com/fastly/ef277a4698188f8561f7d2a20600799493a031e3c8998409056905c83976881f.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=3473',
  priceDollars: 35,
  msrpDollars: 70,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
